<template>
    <div class="delivery-fault">
        <div class="delivery-fault-info">
            <div class="delivery-fault-date">
                <span class="label">时间区间：</span>
                <el-date-picker
                        size="mini"
                        v-model="makeTimeRange"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <el-row class="delivery-fault-chart">
                <el-col :span="14">
                    <delivery-fault-pie></delivery-fault-pie>
                </el-col>
                <el-col :span="10">
                    <delivery-fault-bar></delivery-fault-bar>
                </el-col>
            </el-row>
        </div>

        <div class="delivery-fault-list">
            <div class="delivery-fault-title">
                <span class="table-name">异常明细</span>
                <span class="data-export">数据导出</span>
                <div class="delivery-fault-date clearfix float-right">
                    <span class="label">时间区间：</span>
                    <el-date-picker
                            size="mini"
                            v-model="makeTimeRange"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
            <el-table :data="faults">
                <el-table-column label="异常名称" align="center" prop="name"></el-table-column>
                <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceUuid"></el-table-column>
                <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="deviceName"></el-table-column>
                <el-table-column label="异常时间" align="center" prop="createdAt"></el-table-column>
            </el-table>

            <el-pagination
                    class="pagination"
                    :current-page="currentPage"
                    :page-size="100"
                    layout="total, prev, pager, next, jumper"
                    :total="400">
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import DeliveryFaultPie from '@/components/DeliveryFaultPie/index.vue'
    import DeliveryFaultBar from '@/components/DeliveryFaultBar/index.vue'
    export default {
        name: '',
        components: {
            DeliveryFaultPie,
            DeliveryFaultBar
        },
        mounted: function () {
        },
        data: function () {
            return {
                makeTimeRange: [],
                pickerOptions: {
                    shortcuts: [{
                        text: this.$t('jin_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0)
                            end.setHours(23, 59, 59, 0)
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zuo_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            start.setHours(0, 0, 0, 0)
                            end.setTime(end.getTime() - 3600 * 1000 * 24);
                            end.setHours(23, 59, 59, 0)

                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_zhou'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_san_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                faults: [
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                ],
                currentPage: 1,
            }
        },
        methods: {},
    }
</script>

<style lang="scss">
    .delivery-fault {
        margin-bottom: $padding;
        display: flex;
        flex-direction: column;

        .delivery-fault-date {
            text-align: right;
            .label {
                font-size: .6rem;
                color: $f_sec_color;
                font-weight: $w1;
            }
            .el-range-input {
                border: none;
            }
            input {
                border: none;
                border-bottom: 1px solid $f_fiv_color;
                font-size: $filter-font-size;
                border-radius: 0;
            }
        }

        .delivery-fault-info {
            border: 1px solid $border_sec_color;
            border-radius: .5rem;
            background-color: $bg_sec_color;
            padding: $padding;
            .delivery-fault-chart {
                height: 20rem;

                .el-col {
                    height: 100%;
                }
            }
        }

        .delivery-fault-list {
            flex: 1;
            margin: $padding 0;
            border: 1px solid $border_sec_color;
            border-radius: .5rem;
            background-color: $bg_sec_color;
            padding: $padding;
            .delivery-fault-title {
                .table-name {
                    color: $f_sec_color;
                    font-weight: $w1;
                    font-size: .8rem;
                }
                .data-export {
                    color: $f_color;
                    font-size: .6rem;
                    display: inline-block;
                    margin-left: $padding-5;
                    cursor: pointer;
                }
                .float-right {
                    float: right;
                }
            }
            .el-table th.is-leaf {
                border-color: $border_th_color;
            }
            .el-table:before {
                background-color: transparent;
            }
            .pagination {
                margin-top: $padding;
                text-align: right;
            }
        }
    }
</style>
